import useSWR from "swr";
import { isEmpty, get } from "lodash";
import Link from "next/link";

import styles from "./BlogLatestArticles.module.scss";
import Image from "grandus-lib/components-atomic/image/Image";

import {
  Card
} from "antd";

const BlogLatestArticles = () => {
  const { data } = useSWR("/api/lib/v1/blogs?perPage=5", (url) =>
    fetch(url).then((r) => r.json())
  );
  const articles = data?.articles;
  if (isEmpty(articles)) {
    return null;
  }
  return (
    <Card
      title="Najnovšie články"
    >
      <ul>
        {articles.map((article) => (
          <li key={`blog-article-${article?.id}`}>
            <Link href="/blog/[id]" as={`/blog/${article?.urlTitle}`}>
              <a>
                {article?.photo ? (
                  <Image
                    photo={get(article, "photo", {})}
                    size={"322x120__cropped"}
                    type={"jpg"}
                  />
                ) : null}
                {article?.title}
              </a>
            </Link>
            <span>{article?.publishTime}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default BlogLatestArticles;
